import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64b5759b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=64b5759b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5759b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b5759b')) {
      api.createRecord('64b5759b', component.options)
    } else {
      api.reload('64b5759b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64b5759b&scoped=true", function () {
      api.rerender('64b5759b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/koofee/scene/index.vue"
export default component.exports